
/* tslint:disable max-line-length | no-trailing-whitespace */
import * as React from 'react';

// @ts-ignore
import LOGO from '../images/logo.png';
import { Classable } from '@shapeable/types';

export const ApplicationLogoInverted: React.FC<Classable> = ({ className }) => (
  <img className={className} src={LOGO} />
);


